document.querySelectorAll('.b-list-modal-item').forEach((block) => {
    const modal = block.querySelector('.b-list-modal-item__modal');
    const modalClose = block.querySelector('.b-list-modal-item__modal-close');
    const trigger = block.querySelector('.b-list-modal-item__title');

    const answerButtons = block.querySelectorAll('.b-list-modal-item__modal-type');
    const modalContent = block.querySelector('.b-list-modal-item__modal-content');
    const message = modalContent?.querySelector('.b-list-modal-item__modal-answer');

    if (!modal || !trigger) return;

    // OPEN (tylko klik w title)
    trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        modal.classList.add('active');
    });

    // CLOSE (przycisk)
    if (modalClose) {
        modalClose.addEventListener('click', (e) => {
            e.stopPropagation();
            modal.classList.remove('active');
            resetAnswer();
        });
    }

    // CLOSE (klik w tło)
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.classList.remove('active');
            resetAnswer();
        }
    });

    // CLOSE (ESC)
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            modal.classList.remove('active');
            resetAnswer();
        }
    });

    // ANSWER HANDLING
    answerButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();

            if (!modalContent || !message) return;

            const isCorrect = btn.dataset.correct === 'true';

            modalContent.classList.add('active');
            modalContent.classList.toggle('is-correct', isCorrect);
            modalContent.classList.toggle('is-wrong', !isCorrect);

            message.textContent = isCorrect
                ? 'Zgadza się! Brawo. To prawidłowa odpowiedź. '
                : 'To jednak nie jest prawidłowa odpowiedź. ';

            // opcjonalnie: blokada ponownego kliku
            answerButtons.forEach(b => b.disabled = true);
        });
    });

    // RESET
    function resetAnswer() {
        if (!modalContent || !message) return;

        modalContent.classList.remove('active', 'is-correct', 'is-wrong');
        message.textContent = '';

        answerButtons.forEach(b => b.disabled = false);
    }
});
